interface ClientResponse {
  client_id: string;
  client_secret: string;
  client_id_issued_at: number;
  grant_types: string[];
}

interface AccessTokenResponse {
  id: string;
  access_token: string;
  refresh_token: string;
  created_at: number;
  expires_in: number;
  token_type: string;
}

interface AuthNResponse {
  expires: number;
  mvpd: string;
  requestor: string;
  userId: string;
}

interface MediaTokenResponse {
  expires: number;
  mvpdId: string;
  requestor: string;
  resource: string;
  serializedToken: string;
  userId: string;
}

export const parseClient = (response: ClientResponse) => {
  const {
    client_id: id,
    client_secret: secret,
    client_id_issued_at: createdMs,
    grant_types: grantTypes,
  } = response;

  return {
    id,
    secret,
    createdMs,
    grantTypes,
  };
};

export const parseAccessToken = (response: AccessTokenResponse) => {
  const {
    id,
    access_token: token,
    refresh_token: refreshToken,
    created_at: clientCreatedMs,
    expires_in: timeToLiveSeconds,
    token_type: tokenType,
  } = response;

  const expiryMs = clientCreatedMs + timeToLiveSeconds * 1000;

  return { id, token, refreshToken, expiryMs, tokenType };
};

// API happens to return similar values right now for mvpd requests, still separating
export const parseAuthN = (response: AuthNResponse) => {
  const { expires, mvpd, requestor, userId } = response;

  return {
    expiresMs: expires,
    mvpd,
    requestor,
    userId,
  };
};

export const parseAuthZ = (response: AuthNResponse) => {
  const { expires, mvpd, requestor, userId } = response;

  return {
    expiresMs: expires,
    mvpd,
    requestor,
    userId,
  };
};

export const parseMediaToken = (response: MediaTokenResponse) => {
  const {
    expires,
    mvpdId,
    requestor,
    resource,
    serializedToken,
    userId,
  } = response;

  return {
    expiresMs: expires,
    mvpdId,
    requestor,
    resource,
    serializedToken,
    userId,
  };
};
